<template>
  <div id="app">
    <app-menu></app-menu>
    <transition name="component-fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Menu from './components/Menu.vue';

export default {
  name: 'app',
  data () {
    return {
    }
  },
  components: {
    AppMenu: Menu,
  },
  watch: {
        '$route' (to, from) {
          $('body,html').stop().animate( { scrollTop: 0 }, 500 )
        }
    },
}
</script>

<style lang="scss">
@font-face {
    font-family: TextCompProBold;
    src: url('./assets/fonts/PFDinTextCompPro-Bold.ttf') format('truetype');
}
@font-face {
    font-family: TextCompProMedium;
    src: url('./assets/fonts/PFDinTextCompPro-Medium.ttf') format('truetype');
}
@font-face {
    font-family: TextCompProReg;
    src: url('./assets/fonts/PFDinTextCompPro-Regular.ttf');
}
@font-face {
    font-family: TextProBold;
    src: url('./assets/fonts/PFDinTextPro-Bold.ttf');
}
@font-face {
    font-family: TextProLight;
    src: url('./assets/fonts/PFDinTextPro-Light.ttf');
}
@font-face {
    font-family: TextProMedium;
    src: url('./assets/fonts/PFDinTextPro-Medium.ttf');
}
@font-face {
    font-family: TextProThin;
    src: url('./assets/fonts/PFDinTextPro-Thin.ttf');
}
@font-face {
    font-family: TextProCondBold;
    src: url('./assets/fonts/PfDinTextCondProBold.ttf');
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100vh;
}

p, a, span, h1, h2, button{
  font-size: 12pt;
  color: white;
  line-height: 1.3;
}
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .2s;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}

.back_link {
  text-align: left;
  font-size: 10pt;
  color: #cba35d;
  box-shadow: 0px 1px 0px #cba35d;
  display: inline-block;
  position: absolute;
  left: auto;
  top: -50%;
  font-family: TextProLight;
  margin-left: 1.5em;
  cursor: pointer;

  &:before {
    content: '←';
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5em;
    margin-left: -1.5em;
    width: 1em;
  }
}

@media all and (max-width: 1024px) {
  html {
    margin-top: 80px !important;
  }

  body {
    background: url(./assets/img/bg_long.jpg) repeat-y top center;
    background-size: cover;
  }

  .fp-section,
  .fp-tableCell {
    height: auto !important;
  }

  .back_link {
    top: 20vh;
    z-index: 999;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue